import { NgModule } from '@angular/core';
import { ThreePanelPageComponent } from './three-panel-page.component';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslationModule } from '@galaxy/crm/static';
import { ThreePanelPageLeftPanelDirective } from './directives/three-panel-page-left-panel.directive';
import { ThreePanelPageCenterPanelDirective } from './directives/three-panel-page-center-panel.directive';
import { ThreePanelPageRightPanelDirective } from './directives/three-panel-page-right-panel.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { ThreePanelPageContentHeaderDirective } from './directives/three-panel-page-content-header.directive';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SidenavContentComponent } from './side-panel/crm-sidenav-content.component';

@NgModule({
  imports: [
    TranslationModule,
    CommonModule,
    MatTabsModule,
    MatIconModule,
    MatTooltipModule,
    GalaxyPageModule,
    MatSidenavModule,
    SidenavContentComponent,
    ThreePanelPageComponent,
    ThreePanelPageLeftPanelDirective,
    ThreePanelPageCenterPanelDirective,
    ThreePanelPageRightPanelDirective,
    ThreePanelPageContentHeaderDirective,
  ],
  exports: [
    ThreePanelPageComponent,
    ThreePanelPageLeftPanelDirective,
    ThreePanelPageCenterPanelDirective,
    ThreePanelPageRightPanelDirective,
    ThreePanelPageContentHeaderDirective,
  ],
})
export class CrmThreePanelPageModule {}
